import moment from 'moment';
import { getPlatformDisplayName, getOrderedPlatformKeys } from './utils';
import { getWeekDisplayRange } from './weekInterval';
import { buildCsv, downloadCsv, sanitizeCsvFilenamePart } from './csv';

export function getActivePlatformKeys(platformKoef) {
    return getOrderedPlatformKeys(
        Object.keys(platformKoef || {}).filter((key) => Number(platformKoef[key]) > 0)
    );
}

export function getEpisodeMetadataMap(episodes) {
    return (episodes || []).reduce((acc, episode) => {
        acc[String(episode.id)] = episode;
        return acc;
    }, {});
}

export function getEpisodeCsvColumns(platformKoef) {
    return [
        { key: 'id', header: 'id' },
        { key: 'name', header: 'name' },
        { key: 'release_date', header: 'release_date' },
        ...getActivePlatformKeys(platformKoef).map((key) => ({
            key,
            header: getPlatformDisplayName(key),
        })),
        { key: 'total', header: 'Total' },
    ];
}

export function getWeeklyCsvColumns(platformKoef) {
    return [
        { key: 'date', header: 'date' },
        ...getActivePlatformKeys(platformKoef).map((key) => ({
            key,
            header: getPlatformDisplayName(key),
        })),
        { key: 'total', header: 'Total' },
    ];
}

function getDateRangeFromRows(rows, dateKey) {
    const dates = (rows || [])
        .map((row) => row[dateKey])
        .filter(Boolean)
        .map((value) => moment(value, 'YYYY-MM-DD'))
        .filter((value) => value.isValid());

    if (dates.length === 0) {
        return { startDate: '', endDate: '' };
    }

    const sortedDates = dates.sort((a, b) => a.valueOf() - b.valueOf());

    return {
        startDate: sortedDates[0].format('YYYY-MM-DD'),
        endDate: sortedDates[sortedDates.length - 1].format('YYYY-MM-DD'),
    };
}

export function getCsvDateRange({
    intervalPreset,
    intervalStartDate,
    intervalEndDate,
    collectedStartWeek,
    collectedEndWeek,
    rows = [],
    rowDateKey = 'release_date',
}) {
    if (intervalPreset !== 'all_time' && intervalStartDate && intervalEndDate) {
        return {
            startDate: intervalStartDate,
            endDate: intervalEndDate,
        };
    }

    if (collectedStartWeek && collectedEndWeek) {
        const range = getWeekDisplayRange(collectedStartWeek, collectedEndWeek);

        return {
            startDate: range.intervalStartDate,
            endDate: range.intervalEndDate,
        };
    }

    return getDateRangeFromRows(rows, rowDateKey);
}

export function buildGraphCsvFilename({
    podcast,
    startDate,
    endDate,
    graph,
}) {
    const channel = sanitizeCsvFilenamePart(podcast || 'podcast');
    const graphName = sanitizeCsvFilenamePart(graph || 'graph');

    return `${channel}_${startDate}_${endDate}_${graphName}.csv`;
}

export function downloadGraphCsv({ rows, columns, filename }) {
    downloadCsv(filename, buildCsv(rows, columns));
}
